window.addEventListener('load', function(){
  var MONTHS=['ian','feb','mar','apr','mai','iun','iul','aug','sep','oct','nov','dec'];
  function pad(n){return('0'+Math.floor(n)).slice(-2);}
  function isBlocked(d,blocked){
    var mo=pad(d.getMonth()+1),dy=pad(d.getDate());
    var ds=d.getFullYear()+'-'+mo+'-'+dy,mmdd=mo+'-'+dy;
    return blocked.some(function(b){return b.d===ds||(b.t==='yearly'&&b.d===mmdd);});
  }
  function isWorkDay(d,arr,blocked){return !!arr[(d.getDay()+6)%7]&&!isBlocked(d,blocked);}
  function nextWorkDay(d,arr,blocked){
    var r=new Date(d.getFullYear(),d.getMonth(),d.getDate());
    r.setDate(r.getDate()+1);
    while(!isWorkDay(r,arr,blocked))r.setDate(r.getDate()+1);
    return r;
  }
  function addDays(from,n,arr,blocked){
    var d=new Date(from.getFullYear(),from.getMonth(),from.getDate());
    for(var i=0;i<n;i++)d=nextWorkDay(d,arr,blocked);
    return d;
  }
  function fmt(d){return d.getDate()+' '+MONTHS[d.getMonth()];}
  function daysBetween(a,b){
    return Math.round((new Date(b.getFullYear(),b.getMonth(),b.getDate())-new Date(a.getFullYear(),a.getMonth(),a.getDate()))/86400000);
  }
  document.querySelectorAll('.sf-card-delivery').forEach(function(el){
    var ch=parseInt(el.dataset.cutoffH)||16;
    var cm=parseInt(el.dataset.cutoffM)||0;
    var procMax=parseInt(el.dataset.procMax)||1;
    var transMin=parseInt(el.dataset.transMin)||1;
    var procDays=JSON.parse(el.dataset.procDays||'[1,1,1,1,1,0,0]');
    var transDays=JSON.parse(el.dataset.transDays||'[1,1,1,1,1,0,0]');
    var blocked=JSON.parse(el.dataset.blocked||'[]');
    var now=new Date();
    var cutoff=new Date(now.getFullYear(),now.getMonth(),now.getDate(),ch,cm,0,0);
    var passed=now>=cutoff;
    var startDay=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    if(passed)startDay.setDate(startDay.getDate()+1);
    var orderDay=new Date(startDay);
    while(!isWorkDay(orderDay,procDays,blocked))orderDay.setDate(orderDay.getDate()+1);
    var procEnd=addDays(orderDay,procMax-1,procDays,blocked);
    var delivMin=addDays(procEnd,transMin,transDays,blocked);
    var today=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    var dMin=daysBetween(today,delivMin);
    if(dMin<=1)el.textContent='🚚 Livrare mâine';
    else if(dMin===2)el.textContent='🚚 Livrare în 2 zile';
    else el.textContent='🚚 Livrare: '+fmt(delivMin);
  });
});